// 给详情页图片拼上参数，如果type为1，为了超长图片把参数改为850
export default function updateImageSrc(htmlString, type) {
    // 使用正则表达式匹配所有 img 标签的 src 属性
    const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/g;
    let updatedHtml = htmlString;
    // let typeVal = type;
    
    // 替换函数
    const replacer = (match, src) => {
        // 检查是否为GIF图片
        const isGif = /\.gif($|\?)/i.test(src);
        
        // 如果是GIF图片，直接返回原内容
        if (isGif) {
            return match;
        }
        
        // 检查 src 是否包含Expires等参数
        const hasExpires = /Expires/.test(src);
        const hasOSSAccessKeyId = /OSSAccessKeyId/.test(src);
        const hasSignature = /Signature/.test(src);
        
        // 如果没有已存在的签名参数，则添加新的OSS处理参数
        if (!hasExpires && !hasOSSAccessKeyId && !hasSignature) {
            const separator = src.includes('?') ? '&' : '?';
            const newSrc = `${src}${separator}x-oss-process=image/resize,m_lfit,w_1080,h_16384/format,webp`;
            return match.replace(src, newSrc);
        }
        return match;
    };
 
    // 执行替换
    updatedHtml = updatedHtml.replace(imgRegex, replacer);
    return updatedHtml;
}